import React from "react";
import { DownArrow } from "shared-components/Components/CustomIcons/DownArrow/web";
import { useFilterBar } from "./hook";
import { useTheme } from "shared-components/Styles/ThemeHook";
import { CloseIcon } from "shared-components/Components/CustomIcons/CloseIcon/web";
import { Modal } from "shared-components/Components/Modal/web";
import './styles.less';

export const FilterBar = ({toggleFilters}) => {
    const { theme } = useTheme();

    const stylesModal = {
        container: {
          flex: 1,
          justifyContent: 'flex-end',
          alignItems: 'center',
        },
        bg: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          width: '100%',
          height: '100%',
        }
    };

    const closeSingleFilterModal = (doCloseFunction = true) => {
        setShowSingleFiltersModal(false);
        document?.body?.classList.remove('no-scroll');
        if(doCloseFunction) {
            typeof filterComponent?.onClose === 'function' && filterComponent?.onClose();
        }
    }

    const {
        items,
        setShowSingleFiltersModal,
        showSingleFilterModal,
        openSingleFilter,
        filterComponent,
        handleApplyFilter
    } = useFilterBar({closeSingleFilterModal});
    
    return (
        <div className="filter-bar filter-bar__container">
            {items.map((item, index) => (
                !item.hidden && 
                <div
                    className={`t1 filter-bar__container--item ${item.active ? "active" : ""} ${item.onlyText ? "text-item" : ""} ${item.id}`}
                    key={index}
                    onClick={()=> {item.OpenFilters ? toggleFilters() : openSingleFilter(item.id) }}
                >
                    <span className="item-icon">{item.icon}</span>
                    <span>{item.label}</span>
                    {
                        item.postIcon ? <span>{item.postIcon}</span> : 
                        (item.active ? 
                            (
                            item.nonDeletable ? <DownArrow color={item.active ? 'white' : 'gray'} /> : 
                            <span onClick={(event) => { item.onDelete();event.stopPropagation() }}><CloseIcon color={'white'} width={12} /></span>
                            ) : 
                            (item.isBool ? <></> :<DownArrow color={item.main ? theme.colors.primaryColorV2 : 'gray'} />)
                        )
                    }
                </div>
            ))}
            
            <Modal
                animation="slide" 
                show={showSingleFilterModal} 
                onClose={()=>{closeSingleFilterModal(true)}}
                showHeader={false}
                containerStyles={{width:'100%'}}
                backdropStyles={{
                    padding: 0,
                    display: 'flex',
                    alignItems: 'flex-end'
                }} bodyStyles={{padding: 0}}
                classes="modal-filter__bar"
            >
                <div style={stylesModal.container} >
                    <div className="modal-filter__content">
                        <div style={{ padding: 20, overflow: "auto" }}>
                            {filterComponent?.component}
                        </div>
                        
                        <div className="modal-filter__footer">
                            <button
                                onClick={() => { 
                                    closeSingleFilterModal(false);filterComponent?.onDelete()} 
                                }
                                className="mobile-clean-filter"
                            >
                                Limpiar filtro
                            </button>

                            <div
                                onClick={handleApplyFilter}
                                className="show-properties"
                            >
                                Ver propiedades
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

        </div>
    );
}